import { useState } from "react";
import { Link } from "react-router-dom";
import { EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, fmtError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/forgot", { email });
      setSent(true);
    } catch (error) {
      toast.error(fmtError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-49px)] flex items-center justify-center p-8">
      <div className="w-full max-w-sm space-y-6">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
          <ArrowLeft size={14} /> Voltar ao login
        </Link>
        {!sent ? (
          <form onSubmit={submit} className="space-y-6">
            <div>
              <EnvelopeSimple size={34} weight="duotone" className="text-primary" />
              <div className="label-eyebrow mt-4">recuperação segura</div>
              <h1 className="font-display text-4xl font-black tracking-tighter mt-2">Recuperar senha.</h1>
              <p className="text-sm text-muted-foreground mt-2">
                Informe seu e-mail. Por segurança, a resposta será a mesma exista ou não uma conta cadastrada.
              </p>
            </div>
            <label className="block">
              <span className="label-eyebrow">e-mail</span>
              <Input type="email" autoComplete="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-1 rounded-none font-mono-data" />
            </label>
            <Button type="submit" disabled={loading} className="w-full rounded-none">
              {loading ? "Enviando…" : "Enviar instruções"}
            </Button>
          </form>
        ) : (
          <div className="border border-border bg-card p-6">
            <h1 className="font-display text-3xl font-black tracking-tighter">Confira seu e-mail.</h1>
            <p className="text-sm text-muted-foreground mt-3">
              Se existir uma conta ativa para esse endereço, enviaremos um link de uso único válido por 30 minutos.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
